import { render, staticRenderFns } from "./ORDER_RECEIVED.vue?vue&type=template&id=89597386"
import script from "./ORDER_RECEIVED.vue?vue&type=script&lang=js"
export * from "./ORDER_RECEIVED.vue?vue&type=script&lang=js"
import style0 from "./ORDER_RECEIVED.vue?vue&type=style&index=0&id=89597386&prod&module=true&lang=less"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports